/**
 * Graph signals for future creator ranking and discovery algorithms.
 * Stub formulas only — not wired into feed or API yet.
 */
export interface CreatorGraphSignals {
  creatorId: string;
  followWeight: number;
  engagementScore: number;
  contentQualityScore: number;
  monetizationScore: number;
}

export interface CreatorGraphSignalInput {
  followers: number;
  publishedPostCount: number;
  completedPurchaseCount: number;
  totalRevenue: number;
}

/** Placeholder: weight derived from follower count (normalized stub). */
export function computeFollowWeightStub(followers: number): number {
  return Math.min(followers / 1000, 1);
}

/** Placeholder engagement formula — not used in production ranking yet. */
export function computeEngagementScoreStub(input: CreatorGraphSignalInput): number {
  const base = input.publishedPostCount * 0.1 + input.followers * 0.01;
  return Math.min(Math.round(base * 100) / 100, 100);
}

/** Stub content quality score — future ML / moderation input. */
export function computeContentQualityScoreStub(input: CreatorGraphSignalInput): number {
  void input;
  return 0;
}

/** Stub monetization score — future revenue-weighted signal. */
export function computeMonetizationScoreStub(input: CreatorGraphSignalInput): number {
  return Math.min(input.totalRevenue / 100, 100);
}

/** Builds a full signal bundle from raw inputs (stub pipeline). */
export function buildCreatorGraphSignals(
  creatorId: string,
  input: CreatorGraphSignalInput,
): CreatorGraphSignals {
  return {
    creatorId,
    followWeight: computeFollowWeightStub(input.followers),
    engagementScore: computeEngagementScoreStub(input),
    contentQualityScore: computeContentQualityScoreStub(input),
    monetizationScore: computeMonetizationScoreStub(input),
  };
}
